import { Redirect } from 'react-router-dom';

import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

import NewMediaPage from '../pages/NewMediaPage';

const MediaLandingPage = lazy(() => import('../pages/MediaLandingPage'));
const MultiCamLandingPage = lazy(() => import('../pages/MultiCamLandingPage'));
const MediaEventPage = lazy(() => import('../pages/MediaEventPage'));
const MediaRequestPage = lazy(() => import('../pages/MediaRequestPage'));
const TripImageHistoryPage = lazy(() => import('../pages/TripImageHistoryPage'));

const routes = [
  {
    path: Location.CAMERA_LP,
    component: MediaLandingPage,
    exact: true,
  },
  {
    path: Location.CAMERA_EVENT_ALL_REDIRECT,
    component: () => <Redirect to='/camera/events' />,
    exact: true,
  },
  {
    path: Location.CAMERA_EVENT_REDIRECT,
    component: () => <Redirect to='/camera/events' />,
    exact: true,
  },
  {
    path: Location.CAMERA_EVENT_FAVORITE_REDIRECT,
    component: () => <Redirect to='/camera/events/favorites' />,
    exact: true,
  },
  {
    path: Location.CAMERA_REQUEST_REDIRECT,
    component: () => {
      const queryParams = new URLSearchParams(window.location.search);
      const mediaId = queryParams.get('media_id');

      if (mediaId) {
        queryParams.delete('media_id');
        queryParams.set('id', mediaId);

        return <Redirect to={`/camera/requests?${queryParams.toString()}`} />;
      }
      return <Redirect to='/camera/requests' />;
    },
    exact: true,
  },

  {
    path: Location.CAMERA_REQUEST_ALL_REDIRECT,
    component: () => <Redirect to='/camera/requests' />,
    exact: true,
  },
  {
    path: Location.CAMERA_REQUESTS_FAVORITE_REDIRECT,
    component: () => <Redirect to='/camera/requests/favorites' />,
    exact: true,
  },
  {
    path: Location.CAMERA_TRIP_IMAGE_PENDING_REDIRECT,
    component: () => <Redirect to='/camera/images' />,
    exact: true,
  },
  {
    path: Location.CAMERA_TRIP_IMAGE_ALL_REDIRECT,
    component: () => <Redirect to='/camera/images/all' />,
    exact: true,
  },
  {
    path: Location.CAMERA,
    component: NewMediaPage,
    accessDeniedDescription: 'ver vídeos da câmera',
    routes: [
      {
        path: Location.CAMERA_TRIP_IMAGE_HISTORY_ALL,
        component: TripImageHistoryPage,
        accessDeniedDescription: 'ver histórico de imagens',
        exact: true,
      },
      {
        path: Location.CAMERA_TRIP_IMAGE_HISTORY,
        component: TripImageHistoryPage,
        accessDeniedDescription: 'ver histórico de imagens',
        exact: true,
      },
      {
        path: Location.CAMERA_REQUESTS_FAVORITES,
        title: locationName[Location.CAMERA_REQUESTS],
        component: MediaRequestPage,
        accessDeniedDescription: 'ver vídeos solicitados da câmera',
        exact: true,
      },
      {
        path: Location.CAMERA_REQUESTS,
        title: locationName[Location.CAMERA_REQUESTS],
        component: MediaRequestPage,
        accessDeniedDescription: 'ver vídeos solicitados da câmera',
        exact: true,
      },
      {
        path: Location.CAMERA_EVENTS,
        title: locationName[Location.CAMERA_EVENTS],
        component: MediaEventPage,
        accessDeniedDescription: 'ver vídeos da câmera',
        exact: true,
      },
      {
        path: Location.CAMERA_EVENTS_FAVORITES,
        title: locationName[Location.CAMERA_EVENTS],
        component: MediaEventPage,
        accessDeniedDescription: 'ver vídeos da câmera',
        exact: true,
      },
      {
        path: Location.CAMERA_EVENTS_DASHBOARD,
        title: locationName[Location.CAMERA_EVENTS],
        component: MediaEventPage,
        accessDeniedDescription: 'ver análises da câmera',
        exact: true,
      },
    ],
  },
];

export default routes;
